import { component as defineComponent } from 'flightjs';

var creativeConsultantModal = function() {
    this.attributes({
        creativeConsultant: '[data-creative-consultant-pay-button]',
    });

    this.after('initialize', function() {
        this.on(this.select('creativeConsultant'), 'click', this.triggerCreativeConsultantContext);
    });

    this.triggerCreativeConsultantContext = function(event) {
        var button = this.select('creativeConsultant');
        this.trigger('hide');
        this.trigger('uiPaymentModalRequested', {
            paymentsInput: button.data('payment-request'),
        });
    };
};

export default defineComponent(creativeConsultantModal);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/contest-creative-consultant-modal.js